import { apiUrl } from './api_config'

const ACCOUNTING_REPORT_ENDPOINT = apiUrl('/reports/accounting')

function getDownloadFilename(response, fallback) {
  const disposition = response.headers.get('Content-Disposition') || ''
  const encodedMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i)
  const plainMatch = disposition.match(/filename="?([^";]+)"?/i)
  if (encodedMatch) return decodeURIComponent(encodedMatch[1])
  return plainMatch?.[1] || fallback
}

async function getErrorMessage(response) {
  try {
    const payload = await response.json()
    return payload?.message || payload?.error
  } catch {
    return null
  }
}

export async function generateAccountingReport(payload) {
  const isList = payload.report_type === 'list'
  const response = await fetch(ACCOUNTING_REPORT_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: isList
        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        : 'application/json',
    },
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    throw new Error(
      (await getErrorMessage(response)) ||
        `Accounting report request failed (${response.status})`,
    )
  }

  if (isList) {
    const blob = await response.blob()
    const filename = getDownloadFilename(
      response,
      `accounting-${payload.entity}-${new Date().toISOString().slice(0, 10)}.xlsx`,
    )
    const downloadUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = downloadUrl
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(downloadUrl)
    return null
  }

  const responsePayload = await response.json()
  return responsePayload?.report || responsePayload?.data || responsePayload
}
